import React from 'react'
import PropTypes from 'prop-types'
import { MODEL_NOTE, modelBadgeClass, modelLabel } from './swimCoachModel'

// Labels the model(s) a conversation's replies came from. `models` is null when
// they could not be loaded, which must not read the same as "none recorded".
export default function SwimCoachModelBadges ({ models }) {
  if (!models) {
    return (
      <span
        className="badge text-bg-secondary"
        title="Models could not be loaded"
      >
        ?
      </span>
    )
  }
  if (!models.length) {
    return (<span className="text-muted" title={MODEL_NOTE}>—</span>)
  }
  return (
    <>
      {models.map((model) => (
        <span
          key={model}
          className={'badge me-1 ' + modelBadgeClass(model)}
          title={model}
        >
          {modelLabel(model)}
        </span>
      ))}
    </>
  )
}

SwimCoachModelBadges.propTypes = {
  models: PropTypes.arrayOf(PropTypes.string)
}
